import React from 'react'
import { SubscriptionBox } from 'src/comps/Molecules/Subscription/SubscriptionBox'
import { useDispatch, useSelector } from 'react-redux'
import { useMarket } from 'src/hooks/useMarket'
import { getSubscriptionStatus } from 'src/effects/SubscriptionStatus/selectors'
import { subscribeRequestAction } from 'src/effects/SubscriptionStatus/actions'

import { Spacer, SubscriptionBoxConnectedBase, SubscriptionBoxContainer } from './styles'

interface INewsletterProps {
  readonly source: string
  readonly variant?: 'section' | 'box'
  readonly bgColor?: string
}

export function SubscriptionBoxConnected({
  source,
  variant = 'section',
  bgColor = '#B494F9', // tokio color (temporal until migration to DS)
}: INewsletterProps) {
  const dispatch = useDispatch()

  const { language, feedbackMessageType, market } = useMarket()

  const subscriptionStatus = useSelector(getSubscriptionStatus)

  const handleSubscribe = (emailToSubscribe: string) => {
    dispatch(
      subscribeRequestAction({
        hash: emailToSubscribe,
        language,
        market,
        feedbackMessageType,
        source,
      })
    )
  }

  if (variant === 'box') {
    return (
      <SubscriptionBox
        onSubscribe={handleSubscribe}
        status={subscriptionStatus}
        bgColor={bgColor}
        variant="standalone"
      />
    )
  }

  return (
    <SubscriptionBoxConnectedBase>
      <SubscriptionBoxContainer>
        <Spacer />
        <SubscriptionBox
          onSubscribe={handleSubscribe}
          status={subscriptionStatus}
          bgColor={bgColor}
        />
      </SubscriptionBoxContainer>
    </SubscriptionBoxConnectedBase>
  )
}

export default SubscriptionBoxConnected
